var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.toastConfig.visible)?_c('div',{class:['toast-container', `toast-${_vm.toastConfig.type}`]},[_c('div',{staticClass:"toast-message"},[_vm._v("\n      "+_vm._s(_vm.toastConfig.message)+"\n    ")]),_c('button',{staticClass:"toast-close-button",on:{"click":_vm.closeToast}},[_vm._v("×")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }